import { useRef } from "react";
import BlurTextScroll from "./BlurTextScroll";
import card1 from "@/assets/cards/CARD-1-CIMA.webp";
import card2 from "@/assets/cards/CARD-2-CIMA.webp";
import card3 from "@/assets/cards/CARD-3-CIMA.webp";
import card4 from "@/assets/cards/CARD-4-CIMA.webp";
import card5 from "@/assets/cards/CARD-5-CIMA.webp";

function TiltCard({
  src,
  variant,
}: {
  src: string;
  variant: "lg" | "sm";
}) {
  const ref = useRef<HTMLDivElement>(null);

  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    // subtle tilt: max ~10deg
    el.style.setProperty("--rx", `${(-y * 10).toFixed(2)}deg`);
    el.style.setProperty("--ry", `${(x * 10).toFixed(2)}deg`);
  };

  const handleLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty("--rx", `0deg`);
    el.style.setProperty("--ry", `0deg`);
  };

  return (
    <div
      ref={ref}
      className={`fg-card fg-card--${variant}`}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
    >
      <div className="fg-card-inner">
        <img src={src} alt="" className="fg-card-img" />
      </div>
    </div>
  );
}

export default function FeaturesGridSection() {
  return (
    <section className="fg-section" id="estrutura">
      <div className="fg-wrap">
        <h2 className="fg-title">
          <BlurTextScroll
            text="Toda estrutura que vai te fazer escalar!"
            scrub={1}
            start="top 85%"
            end="top 45%"
          />

        </h2>
        <div className="fg-grid">
          <TiltCard src={card1} variant="lg" />
          <TiltCard src={card2} variant="lg" />
          <TiltCard src={card3} variant="sm" />
          <TiltCard src={card4} variant="sm" />
          <TiltCard src={card5} variant="sm" />
        </div>
      </div>
    </section>
  );
}
